import React from 'react';
import { useIntl } from 'react-intl';
import './Spinner.scss';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  block?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  label,
  block = false,
  className = '',
}) => {
  const { formatMessage } = useIntl();
  const resolvedLabel = label ?? formatMessage({ id: 'common.loading' });
  const classes = [
    'spinner',
    `spinner--${size}`,
    block ? 'spinner--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-live="polite" aria-label={resolvedLabel}>
      <span className="spinner__circle" aria-hidden="true" />
    </div>
  );
};

export default Spinner;
